import React from 'react'

const NotFound = () => {
  return (
    <div className='w-full h-[90vh] text-white flex justify-center items-center text-[3rem]'>
      Not Found
    </div>
  )
}

export default NotFound
